import React from "react";
import styled from "styled-components";
import { TestimonialCard, TestimonialCardProps } from "../TestimonialCard/TestimonialCard";
import globalStyles from "../../constants/globalStyles/theme.json";

const { spacing, breakpoints } = globalStyles;

interface CarouselProps {
  testimonials: TestimonialCardProps[];
}

const Carousel: React.FC<CarouselProps> = ({ testimonials }) => {
  return (
    <CarouselContainer>
      {testimonials.map((testimonial, index) => (
        <TestimonialCard key={index} {...testimonial} />
      ))}
    </CarouselContainer>
  );
};

const CarouselContainer = styled.div`
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  align-items: baseline;

  @media (min-width: ${breakpoints.xl}) {
    justify-content: center;
  }

  & > * {
    margin-right: ${spacing.space16};
  }

  & > *:last-child {
    margin-right: ${spacing.space32};
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export default Carousel;
